
/**
 * 视口方向导航器外部按钮支持的有限动作集合。
 *
 * 设计说明：
 * 使用常量对象与联合类型表达有限状态，避免 TypeScript 枚举产生额外运行时代码。
 */
export const ViewportGizmoControlAction = {
  /** 视图向上绕相机局部右轴旋转。 */
  OrbitUp: 'orbit-up',
  /** 视图向下绕相机局部右轴旋转。 */
  OrbitDown: 'orbit-down',
  /** 视图向左绕相机朝上轴旋转。 */
  OrbitLeft: 'orbit-left',
  /** 视图向右绕相机朝上轴旋转。 */
  OrbitRight: 'orbit-right',
  /** 视图绕观察方向逆时针滚转。 */
  RollCounterClockwise: 'roll-counter-clockwise',
  /** 视图绕观察方向顺时针滚转。 */
  RollClockwise: 'roll-clockwise',
} as const;

/** 视口方向导航器外部按钮动作。 */
export type ViewportGizmoControlAction =
  (typeof ViewportGizmoControlAction)[keyof typeof ViewportGizmoControlAction];

/** 全部外部按钮动作的只读集合。 */
const VIEWPORT_GIZMO_CONTROL_ACTIONS: readonly ViewportGizmoControlAction[] =
  Object.values(ViewportGizmoControlAction);

/**
 * 判断未知值是否属于视口方向导航器支持的动作。
 *
 * @param value 待检查值。
 * @returns 属于有限动作集合时返回 `true`。
 */
export function isViewportGizmoControlAction(
  value: unknown,
): value is ViewportGizmoControlAction {
  // 集中从常量对象读取允许值，新增动作时无需维护第二份分支。
  return VIEWPORT_GIZMO_CONTROL_ACTIONS.some((action) => action === value);
}

